import axios from './axiosInstance';
import { APIInvitation, APICreateInvitationParams } from '../../types';

interface SportAreaParams {
  sport: string;
  areaId: string;
}

interface CreateInvitationParams extends SportAreaParams {
  invitations: APICreateInvitationParams[];
}

interface SelfInvitationEntry {
  inviteeEmail: string;
  // For role invitations
  role?: string;
  // For user group invitations
  userGroupId?: string;
}

interface CreateSelfInvitationsParams extends SportAreaParams {
  invitations: SelfInvitationEntry[];
}

interface DeleteInvitationParams extends SportAreaParams {
  invitationId: string;
}

const createInvitation = ({ sport, areaId, invitations }: CreateInvitationParams): Promise<APIInvitation[]> => {
  return axios.put(
    `${sport}/areas/${areaId}/invitations`,
    invitations,
  )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const createSelfInvitations = ({ sport, areaId, invitations }: CreateSelfInvitationsParams): Promise<APIInvitation[]> => {
  return axios.put(
    `${sport}/areas/${areaId}/selfinvitations`,
    invitations,
  )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const getInvitations = ({ sport, areaId }: SportAreaParams): Promise<APIInvitation[] | void> => {
  return axios.get(`/${sport}/areas/${areaId}/invitations`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

const deleteInvitation = ({ sport, areaId, invitationId }: DeleteInvitationParams): Promise<any> => {
  return axios.delete(`/${sport}/areas/${areaId}/invitations/${invitationId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

const functions = {
  createInvitation,
  createSelfInvitations,
  getInvitations,
  deleteInvitation,
};

export default functions;
